import './ecocode-trustpilot-sender-config.scss';
import template from './ecocode-trustpilot-sender-config.html.twig';

const {Component} = Shopware;
const {object} = Shopware.Utils;

Component.register('ecocode-trustpilot-sender-config', {
    template,
    inject: ['ecocodeTrustpilotConfigurationService'],
    props: {
        value: {
            type: Object,
            default: null
        }
    },
    emits: ['update:value'],
    data() {
        return {
            currentValue: {
                sender: '',
                replyTo: '',
                useCustom: false
            }
        }
    },
    watch: {
        currentValue: {
            handler(newValue) {
                if (newValue.useCustom === false) {
                    newValue.sender = '';
                    newValue.replyTo = '';
                }

                const changes = object.getObjectDiff(this.value ?? {}, newValue);

                if(Object.keys(changes).length > 0) {
                    this.$emit('update:value', object.cloneDeep(newValue));
                }
            },
            deep: true
        },
},
    mounted() {
        if (this.value) {
            this.currentValue = {
                ...this.currentValue,
                ...object.deepCopyObject(this.value)
            }
        }
    }
});
